export default __webpack_public_path__ + "static/media/green2.83c40d84.svg";